/*
  ADA / WCAG 2.2 AA fixes that need JavaScript (loaded from snippets/head.liquid).
*/
(function () {
  'use strict';

  var NEW_TAB_TEXT = ' (opens in a new tab)';

  // Warn screen reader users when a link opens a new tab (WCAG 3.2.5 / G201)
  function labelNewTabLinks(root) {
    (root || document).querySelectorAll('a[target="_blank"]:not([data-a11y-new-tab])').forEach(function (link) {
      link.setAttribute('data-a11y-new-tab', '');
      var label = link.getAttribute('aria-label');
      if (label) {
        if (label.indexOf('new tab') === -1) link.setAttribute('aria-label', label + NEW_TAB_TEXT);
        return;
      }
      if ((link.textContent || '').indexOf('new tab') !== -1) return;
      var hint = document.createElement('span');
      hint.className = 'visually-hidden';
      hint.textContent = NEW_TAB_TEXT;
      link.appendChild(hint);
    });
  }

  // Theme tabs (li.tab-link[data-tab] in [data-tabs-holder]) as ARIA tabs:
  // roles, selected state, roving tabindex, arrow/Home/End keys (WCAG 2.1.1, 4.1.2)
  var tabUid = 0;

  function ownTabs(holder) {
    return Array.prototype.filter.call(holder.querySelectorAll('[data-tab]'), function (tab) {
      return tab.closest('[data-tabs-holder]') === holder;
    });
  }

  function syncTabs(holder) {
    ownTabs(holder).forEach(function (tab) {
      var selected = tab.classList.contains('current');
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
    });
  }

  function setupTabs(holder) {
    if (holder.hasAttribute('data-a11y-tabs')) return;
    var tabs = ownTabs(holder);
    if (!tabs.length) return;
    holder.setAttribute('data-a11y-tabs', '');

    var list = tabs[0].parentElement;
    if (list) list.setAttribute('role', 'tablist');

    tabs.forEach(function (tab) {
      var index = tab.getAttribute('data-tab');
      var panel = Array.prototype.filter.call(holder.querySelectorAll('.tab-content-' + index), function (el) {
        return el.closest('[data-tabs-holder]') === holder;
      })[0];
      tab.setAttribute('role', 'tab');
      if (!tab.id) tab.id = 'a11y-tab-' + ++tabUid;
      if (panel) {
        if (!panel.id) panel.id = tab.id + '-panel';
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.setAttribute('aria-controls', panel.id);
      }
    });

    syncTabs(holder);

    holder.addEventListener('keydown', function (event) {
      var tab = event.target.closest && event.target.closest('[role="tab"]');
      if (!tab || tab.closest('[data-tabs-holder]') !== holder) return;

      // Theme activates on keyup only while body.is-focused; Space also scrolled the page
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        tab.click();
        return;
      }

      var usable = ownTabs(holder).filter(function (t) {
        return t.getClientRects().length > 0;
      });
      var i = usable.indexOf(tab);
      var next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = usable[(i + 1) % usable.length];
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = usable[(i - 1 + usable.length) % usable.length];
      else if (event.key === 'Home') next = usable[0];
      else if (event.key === 'End') next = usable[usable.length - 1];
      if (!next) return;

      event.preventDefault();
      next.click();
      next.focus();
    });

    // Keep aria-selected/tabindex in step with the theme's .current class
    new MutationObserver(function () {
      syncTabs(holder);
    }).observe(holder, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function setupAllTabs(root) {
    (root || document).querySelectorAll('[data-tabs-holder]').forEach(setupTabs);
  }

  // Variant buttons: theme marks sold-out/unavailable values with a class only (visual);
  // mirror it as hidden label text so screen readers hear it (WCAG 1.3.1, 4.1.2)
  function variantStatusText(input) {
    var strings = (window.theme && window.theme.strings) || {};
    if (input.classList.contains('sold-out')) return strings.soldOut || 'Sold out';
    if (input.classList.contains('unavailable')) return strings.unavailable || 'Unavailable';
    return '';
  }

  function syncVariantStatus(input) {
    if (input.type !== 'radio' || !input.id) return;
    var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    if (!label) return;
    var text = variantStatusText(input);
    var hint = label.querySelector('.a11y-variant-status');
    if (!text) {
      if (hint) hint.remove();
      return;
    }
    if (!hint) {
      hint = document.createElement('span');
      hint.className = 'visually-hidden a11y-variant-status';
      label.appendChild(hint);
    }
    if (hint.textContent !== ', ' + text) hint.textContent = ', ' + text;
  }

  var variantObserver = 'MutationObserver' in window && new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      syncVariantStatus(m.target);
    });
  });

  function setupVariantStatus(root) {
    (root || document).querySelectorAll('input[data-single-option-selector]:not([data-a11y-status])').forEach(function (input) {
      input.setAttribute('data-a11y-status', '');
      syncVariantStatus(input);
      if (variantObserver) variantObserver.observe(input, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Landing pages built from sections/GemPages often have no <h1>; give them a hidden one
  // named after the page so screen readers get a page heading (WCAG 1.3.1, 2.4.6)
  function ensurePageHeading() {
    var main = document.getElementById('MainContent');
    var title = main && main.getAttribute('data-a11y-page-title');
    if (!title || document.querySelector('h1')) return;
    var h1 = document.createElement('h1');
    h1.className = 'visually-hidden';
    h1.textContent = title;
    main.insertBefore(h1, main.firstChild);
  }

  // Wide tables (size charts, product descriptions) sit in sideways-scrolling wrappers that a
  // keyboard can't reach. While a wrapper actually overflows and has nothing focusable inside,
  // make it a named, focusable region so arrow keys can scroll it (WCAG 2.1.1)
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function scrollParent(table) {
    for (var el = table.parentElement, i = 0; el && el !== document.body && i < 5; el = el.parentElement, i++) {
      var style = getComputedStyle(el);
      if (/(auto|scroll)/.test(style.overflowX)) return el;
    }
    return null;
  }

  function scrollRegionName(box) {
    var caption = box.querySelector('caption');
    if (caption && caption.textContent.trim()) return caption.textContent.trim();
    var panel = box.closest('[role="tabpanel"][aria-labelledby]');
    var tab = panel && document.getElementById(panel.getAttribute('aria-labelledby'));
    if (tab && tab.textContent.trim()) return tab.textContent.trim().replace(/\s+/g, ' ');
    // nearby heading only — walking further up lands on the page title, which says nothing about the table
    for (var el = box, depth = 0; el && el !== document.body && depth < 3; el = el.parentElement, depth++) {
      for (var prev = el.previousElementSibling; prev; prev = prev.previousElementSibling) {
        var heading = prev.matches('h1, h2, h3, h4, h5, h6') ? prev : prev.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading && heading.textContent.trim()) return heading.textContent.trim().replace(/\s+/g, ' ');
      }
    }
    return 'Table';
  }

  function syncScrollRegion(box) {
    var overflows = box.scrollWidth > box.clientWidth + 1 && box.clientHeight > 0;
    var managed = box.hasAttribute('data-a11y-scroll-region');
    if (overflows && !managed) {
      if (box.matches(FOCUSABLE) || box.querySelector(FOCUSABLE)) return;
      // remember which attributes we added so we only ever remove our own
      var added = ['tabindex'];
      box.setAttribute('tabindex', '0');
      if (!box.hasAttribute('role')) {
        box.setAttribute('role', 'region');
        added.push('role');
      }
      if (!box.hasAttribute('aria-label') && !box.hasAttribute('aria-labelledby')) {
        box.setAttribute('aria-label', scrollRegionName(box) + ' (scrollable)');
        added.push('aria-label');
      }
      box.setAttribute('data-a11y-scroll-region', added.join(' '));
    } else if (!overflows && managed) {
      box.getAttribute('data-a11y-scroll-region').split(' ').forEach(function (name) {
        box.removeAttribute(name);
      });
      box.removeAttribute('data-a11y-scroll-region');
    }
  }

  var scrollRegionObserver = 'ResizeObserver' in window && new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      syncScrollRegion(entry.target.tagName === 'TABLE' ? scrollParent(entry.target) : entry.target);
    });
  });

  function setupScrollRegions(root) {
    (root || document).querySelectorAll('table:not([data-a11y-scroll-checked])').forEach(function (table) {
      table.setAttribute('data-a11y-scroll-checked', '');
      var box = scrollParent(table);
      if (!box) return;
      // table resizes too (content/fonts load) — its wrapper may start overflowing without resizing
      if (scrollRegionObserver) scrollRegionObserver.observe(table);
      if (box.hasAttribute('data-a11y-scroll-watched')) return;
      box.setAttribute('data-a11y-scroll-watched', '');
      syncScrollRegion(box);
      if (scrollRegionObserver) scrollRegionObserver.observe(box);
    });
  }

  function init() {
    ensurePageHeading();
    labelNewTabLinks();
    setupAllTabs();
    setupVariantStatus();
    setupScrollRegions(); // after tabs: names regions from their tab label
    // Cart drawer, quick view and app widgets render links after load
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          labelNewTabLinks();
          setupAllTabs();
          setupVariantStatus();
          setupScrollRegions();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
